import { Injectable, inject } from "@angular/core";
import { TypeAheadResult } from "~app/common/models/type-ahead-result.model";
import { WebinstallningarService } from "../webinstallningar/webinstallningar.service";

@Injectable({
    providedIn: "root"
})
export class TypeaheadService {
    readonly webInstallningarKey = "SenastAnvandaIFalt";

    private readonly webinstallningarService = inject(WebinstallningarService);

    private saveTimeout;

    private static readonly PreloadedResults = {};

    addToPreload(key: string, value: TypeAheadResult) {
        const contents = this.getPreload(key);
        this.getPreload(key).push(value);
        this.save(key, contents);
    }

    clearPreload(key: string) {
        this.save(key, []);
    }

    getPreload<T>(key: string, defaultText: string = null) {
        let contents = this.getFromWebinstallningar()[key];
        if (contents === undefined) {
            contents = [];
        }
        if (contents.length === 0 && defaultText) {
            contents.push(new TypeAheadResult(defaultText));
        }
        return contents;
    }

    removeFromPreload(key: string, value: TypeAheadResult) {
        const contents = this.getPreload(key);
        const index = contents.indexOf(value);
        if (index > 0) {
            contents.splice(index, 1);
        }
        this.save(key, contents);
    }

    private getFromWebinstallningar() {
        const contents = this.webinstallningarService.get(this.webInstallningarKey);
        return contents ? contents : {};
    }

    private save(key: string, items: any[]) {
        const contents = this.getFromWebinstallningar();
        contents[key] = items;

        if (this.saveTimeout) {
            clearTimeout(this.saveTimeout);
        }

        this.saveTimeout = setTimeout(() => {
            this.webinstallningarService.setAsync(this.webInstallningarKey, contents);
        });
    }
}
